import { getImageProps } from 'utils/images'

export const CHECKOUT_CARDS_IMAGES = [
  getImageProps('shared', 'subscription', 'logoVisa'),
  getImageProps('shared', 'subscription', 'logoAmex'),
  getImageProps('shared', 'subscription', 'logoDiscover'),
  getImageProps('shared', 'subscription', 'logoMastercard'),
  getImageProps('shared', 'subscription', 'logoPayPal'),
  getImageProps('shared', 'subscription', 'logoGooglePay'),
  getImageProps('shared', 'subscription', 'logoApplePay'),
]
